import script from "./payali.vue?vue&type=script&setup=true&lang=js"
export * from "./payali.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__